// Adapted from davinci-elections apps/web/src/theme/recipes/table.ts @ 6e23f58
import { defineSlotRecipe } from '@chakra-ui/react'
import { tableAnatomy } from '@chakra-ui/react/anatomy'

/**
 * Tables (R113): the header row is a band of the canvas colour (`bg.canvas`, visible against the white table) with
 * 500-weight muted labels and a stronger rule under it, the rows are the content surface with a hairline between them and a hover fill, so a row reads as one line of
 * data and the header as its legend.
 */
export const Table = defineSlotRecipe({
  slots: tableAnatomy.keys(),
  base: {
    caption: {
      p: 4,
    },
    header: {
      bg: 'bg.canvas',
      borderBottom: '1px solid',
      borderColor: 'border.emphasized',
    },
    columnHeader: {
      color: 'fg.muted',
      fontWeight: 'bold',
      borderBottomColor: 'border.emphasized',
    },
    row: {
      bg: 'bg',
    },
    cell: {
      borderBottomColor: 'border',
    },
  },
  variants: {
    variant: {
      line: {
        row: {
          bg: 'bg',
          _hover: { bg: 'bg.subtle' },
        },
      },
    },
  },
})
